import {environment, isDevMode} from '@shared-types';
import {jwtDecode, JwtPayload} from 'jwt-decode';
import {UserRoleType} from '../user';
import {PermissionType} from '../users';

export type IJwtTimings = {
	issuedAtMs: number;
	expiresAtMs: number;
	notBeforeMs: number;
	lifetimeMs: number;
	refreshAtMs: number;
	shouldRefresh: (now: number) => boolean;
};

export type IJwt = Partial<JwtToken> & JwtPayload;

export class JwtToken {
	nameid: string;
	unique_name: string;
	fullname: string;
	permission: PermissionType | PermissionType[];
	permanent: string | string[];
	role: UserRoleType | UserRoleType[];
	language: string;
	company_name: string;

	// Metadata:
	debugger;
	timings: IJwtTimings;

	constructor(jwtToken: string) {
		const decodedToken: IJwt = jwtDecode<IJwt>(jwtToken);
		this.nameid = decodedToken.nameid;
		this.unique_name = decodedToken.unique_name;
		this.fullname = decodedToken.fullname;
		this.permission = decodedToken.permission;
		this.permanent = decodedToken.permanent;
		this.role = decodedToken.role;
		this.language = decodedToken.language;
		this.company_name = decodedToken.iss;
		this.timings = computeTokenTimings(decodedToken);
	}

	get permissions(): PermissionType[] {
		let permissions = Array.isArray(this.permission) ? this.permission : [this.permission];
		if (this.permanent) {
			permissions = [...permissions, PermissionType.permanent];
		}

		if (isDevMode() || (Array.isArray(this.role) && [UserRoleType.Administrator, UserRoleType.Superuser].some(role => this.role.includes(role)) && Array.isArray(this.permission))) {
			permissions = [...permissions, PermissionType.developer];
		}
		if (this.role.includes(UserRoleType.Administrator) && this.company_name === 'Admin') {
			permissions = [...permissions, PermissionType.sysadmin];
		}
		return permissions;
	}
}

export function computeTokenTimings(decodedToken: IJwt | string): IJwtTimings {
	if (typeof decodedToken === 'string') decodedToken = jwtDecode<IJwt>(decodedToken);
	const {iat, exp, nbf} = decodedToken;
	const {TIME, AuthSettings} = environment;
	// ממירים לשניות → מילישניות
	const issuedAtMs = iat * TIME.SECOND;
	const expiresAtMs = exp * TIME.SECOND;
	const notBeforeMs = nbf * TIME.SECOND;

	// משך חיי הטוקן (ms)
	const lifetimeMs = expiresAtMs - issuedAtMs;

	// סטיית שעון מותרת (ClockSkew)
	const clockSkewMs = AuthSettings.clockSkewMs;

	// buffer לרענון לפני פקיעה מוחלטת
	const refreshBufferMs = AuthSettings.refreshBufferMs;

	// הנקודה שבה נרענן מראש (ms)
	const refreshAtMs = expiresAtMs - clockSkewMs - refreshBufferMs;

	return {
		issuedAtMs,
		expiresAtMs,
		notBeforeMs,
		lifetimeMs,
		refreshAtMs,
		shouldRefresh: (now: number = Date.now()) => now > refreshAtMs,
	};
}
